module.exports = __webpack_public_path__ + "static/media/LogoDesign.0586ccfc.png";